<template>
  <!-- s::로그인 모달창 -->
  <div v-if="mode === 'login'" class="modal-popup modal-signin">
    <button type="button" class="close-modal" aria-label="닫기" @click="closeModal">
      <img src="@/assets/images/icon/ico_close_b.svg" alt=""/>
    </button>
    <form>
      <fieldset>
        <div class="field">
          <div class="label">아이디</div>
          <div class="input-box">
            <input v-model="accountId" @input="validateForm" name="accountId" type="text"/>
          </div>
          <p v-if="accountIdError" class="txt" style="color: red;">{{ accountIdError }}</p>
        </div>
        <div class="field">
          <div class="label">비밀번호</div>
          <div class="input-box">
            <div class="pwd-wrap">
              <input v-model="accountPwd" @input="validateForm" name="accountPwd" :type="accountPwdFieldType" @keyup.enter="handleLogin"/>
              <button @click="toggleAccountPwdVisibility" type="button" :class="{ on: accountPwdFieldType === 'text' }"
                      class="btn-pwd"
                      :aria-label="accountPwdFieldType === 'text' ? '비밀번호 숨기기' : '비밀번호 표시'"
                      :aria-pressed="accountPwdFieldType === 'text'"></button>
            </div>
          </div>
          <p v-if="accountPwdError" class="txt" style="color: red;">{{ accountPwdError }}</p>
        </div>
        <div class="button-box">
          <button type="button" @click="handleLogin">로그인</button>
        </div>
      </fieldset>
    </form>
    <div class="link-box">
      <button type="button" class="btn modal-find" @click="changeTabMode('id')">아이디 찾기</button>
      <button type="button" class="btn modal-find" @click="changeTabMode('pwd')">비밀번호 찾기</button>
      <router-link :to="{name:'Signup'}" class="btn" @click="closeModal">회원가입</router-link>
    </div>
    <OAuthLogin/>
  </div>
  <!-- e::로그인 모달창 -->

  <!-- s::아이디 비번찾기 모달창 -->
  <div class="modal-popup modal-find" v-if="mode === 'findInfo'">
    <div class="find-tab">
      <button type="button" :class="tabMode === 'id' ? 'on' : ''" @click="changeTabMode('id')">아이디 찾기</button>
      <button type="button" :class="tabMode === 'pwd' ? 'on' : ''" @click="changeTabMode('pwd')">비밀번호 찾기</button>
    </div>
    <div class="find-cont">
      <div id="find1" class="tab-cont" v-if="tabMode === 'id'">
        <h2 v-if="isIdentityEmailOnly">
          이메일 인증을 통해<br>
          아이디를 확인합니다.
        </h2>
        <h2 v-else>
          휴대폰 본인인증을 통해<br>
          아이디를 확인합니다.
        </h2>
        <p v-if="isIdentityEmailOnly && identityNotice" class="identity-notice">{{ identityNotice }}</p>
        <button v-if="!isIdentityEmailOnly" @click="openNicePopup" type="button">휴대폰 본인인증</button>
        <button @click="openEmailFind" type="button" class="btn-email-find">
          {{ isIdentityEmailOnly ? '✉️ 이메일 인증' : '🌐 해외 거주자 인증' }}
        </button>
        <p>
          문의 사항은 hello@article21.co.kr로 연락주시기 바랍니다.
        </p>
      </div>
      <div id="find2" class="tab-cont" v-if="tabMode === 'pwd'">
        <h2 v-if="isIdentityEmailOnly">
          이메일 인증을 통해<br>
          비밀번호를 변경합니다.
        </h2>
        <h2 v-else>
          가입한 <strong>아이디</strong>를 입력한 후<br>
          휴대폰 본인인증을 통해 비밀번호를 변경합니다.
        </h2>
        <p v-if="isIdentityEmailOnly && identityNotice" class="identity-notice">{{ identityNotice }}</p>
        <div v-if="!isIdentityEmailOnly" class="input-wrap">
          <input v-model="accountId" type="text">
        </div>
        <button v-if="!isIdentityEmailOnly" @click="openNicePopup" type="button">휴대폰 본인인증</button>
        <button @click="openEmailFind" type="button" class="btn-email-find">
          {{ isIdentityEmailOnly ? '✉️ 이메일 인증' : '🌐 해외 거주자 인증' }}
        </button>
        <p class="email-find-note">이메일 인증 시 아이디 입력 없이 진행됩니다.</p>
        <p>
          문의 사항은 hello@article21.co.kr로 연락주시기 바랍니다.
        </p>
      </div>
    </div>
    <div class="button-box">
      <button @click="closeModal" type="button" class="close-modal">닫기</button>
    </div>
  </div>

  <div class="modal-popup modal-find" v-if="tabMode === 'findIdResult'">
    <div class="find-cont">
      <div id="find1" class="tab-cont">
        <h2>고객님의 아이디는<br>{{ accountId }} 입니다.</h2>
      </div>
    </div>
    <div class="button-box">
      <button @click="closeModal" type="button" class="close-modal">닫기</button>
    </div>
  </div>

  <div class="modal-popup modal-signin" v-if="tabMode === 'findPwdResult'">
    <button type="button" class="close-modal" aria-label="닫기" @click="closeModal">
      <img src="@/assets/images/icon/ico_close_b.svg" alt=""/>
    </button>
    <div class="find-cont">
      <div id="find2" class="tab-cont">
        <h2>비밀번호 변경</h2>
        <form>
          <fieldset>
            <div class="field">
              <div class="input-box">
                <div class="pwd-wrap">
                  <input ref="accountPwd1Ref" :type="accountPwd1FieldType" v-model="accountPwd1" maxlength="16"
                         @input="validateAccountPwdForm" placeholder="8~16자의 영문 대/소문자+숫자+특수문자">
                  <button @click="toggleAccountPwd1Visibility" :class="{ on: accountPwd1FieldType === 'text' }"
                          type="button" class="btn-pwd"
                          :aria-label="accountPwd1FieldType === 'text' ? '비밀번호 숨기기' : '비밀번호 표시'"
                          :aria-pressed="accountPwd1FieldType === 'text'"></button>
                </div>
              </div>
              <p v-if="accountPwdError1" class="txt" style="color: red;">{{ accountPwdError1 }}</p>
            </div>
            <div class="field">
              <div class="input-box">
                <div class="pwd-wrap">
                  <input ref="accountPwd2Ref" :type="accountPwd2FieldType" v-model="accountPwd2" maxlength="16"
                         @input="validateAccountPwdForm" placeholder="8~16자의 영문 대/소문자+숫자+특수문자">
                  <button @click="toggleAccountPwd2Visibility" :class="{ on: accountPwd2FieldType === 'text' }"
                          type="button" class="btn-pwd"
                          :aria-label="accountPwd2FieldType === 'text' ? '비밀번호 숨기기' : '비밀번호 표시'"
                          :aria-pressed="accountPwd2FieldType === 'text'"></button>
                </div>
              </div>
              <p v-if="accountPwdError2" class="txt">비밀번호를 한 번 더 입력해 주세요.</p>
              <p v-if="accountPwdError2" class="txt" style="color: red;">{{ accountPwdError2 }}</p>
            </div>
            <div class="button-box">
              <button @click="changeAccountPwd" type="button">확인</button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
  <!-- e::아이디 비번찾기 모달창 -->

  <!-- s::이메일 인증 찾기 모달 -->
  <EmailVerificationModal
      v-if="showEmailFindModal"
      purpose="find"
      @close="showEmailFindModal = false"
      @verified="onEmailFindVerified"
  />
  <!-- e::이메일 인증 찾기 모달 -->
</template>

<script setup>
import {onMounted, ref, computed, watch, onUnmounted, nextTick} from 'vue';
import OAuthLogin from "@/components/auth/OAuthLogin.vue";
import EmailVerificationModal from "@/components/auth/EmailVerificationModal.vue";
import {useAuthStore} from "@/store/auth.module";
import router from "@/router";
import {apiClient} from "@/services/auth-header";
import {useNicePopup} from "@/composables/useNicePopup";
import {useIdentityMode} from "@/composables/useIdentityMode";
import {useUiStore} from "@/store/useUiStore";
import {useRoute} from "vue-router";
import { useAnalytics } from "@/composables/useAnalytics";
import { useModalAnalytics, MODAL_TYPES } from "@/composables/useModalAnalytics";

const route = useRoute();
const uiStore = useUiStore();
const authStore = useAuthStore();

// Analytics 통합
const { trackModalOpen, trackModalClose, trackModalInteraction } = useModalAnalytics();
let loginModalId = null;
const accountId = ref('');
const accountPwd = ref('');
const accountPwd1 = ref('');
const accountPwd2 = ref('');
const accountIdError = ref('');
const accountPwdError = ref('');
const pwdUpdateToken = ref('');
const tabMode = ref('findId');

const mode = computed(() => uiStore.loginMode);

const validateForm = async () => {
  let isValid = true;
  if (!accountId.value) {
    accountIdError.value = '아이디를 입력해 주세요.';
    isValid = false;
  } else {
    accountIdError.value = '';
  }

  if (!accountPwd.value) {
    accountPwdError.value = '비밀번호를 입력해 주세요.';
    isValid = false;
  } else {
    accountPwdError.value = '';
  }
  return isValid;
}

const closeModal = (e, isPop = false) => {
  tabMode.value = "none";
  uiStore.setLoginMode('none');
  if (!isPop) {
    window.history.back();
  }
};

const changeTabMode = (mode) => {
  uiStore.setLoginMode('findInfo');
  tabMode.value = mode;
};

const handleLogin = async (event) => {
  // event.preventDefault();
  const { trackFormSubmit } = useAnalytics();
  
  try {
    await authStore.login({accountId: accountId.value, accountPwd: accountPwd.value});
    
    // 로그인 성공 추적
    trackFormSubmit('login', 'login_form', true);
    
    uiStore.setLoginMode('none');
    if ($(".h-cont").hasClass("active")) {
      $(".h-cont").removeClass("active");
    }
    if ($(".nav-icon").hasClass("open")) {
      $(".nav-icon").removeClass("open");
    }
    window.history.back();
    await router.push({name: route.name});
    // location.reload();
  } catch (error) {
    console.error("error", error);
    
    // 로그인 실패 추적
    trackFormSubmit('login', 'login_form', false, error.message || 'Login failed');
  }
};
const accountPwdFieldType = ref('password');
const toggleAccountPwdVisibility = () => {
  accountPwdFieldType.value = accountPwdFieldType.value === 'password' ? 'text' : 'password';
};

const {open} = useNicePopup();

// 본인 인증 모드 (mimio#74). EMAIL 이면 휴대폰 본인인증 버튼을 감춘다.
const {mode: identityMode, notice: identityNotice, load: loadIdentityMode} = useIdentityMode();
const isIdentityEmailOnly = computed(() => identityMode.value === 'EMAIL');

const openNicePopup = async () => {
  if (tabMode.value === "pwd") {
    if (!accountId.value) {
      alert("아이디를 입력해 주세요.");
      return;
    }
    localStorage.setItem("accountId", accountId.value);
  }

  await open({
    type: tabMode.value,
    onPopupClose: () => {
      if (tabMode.value === "id") {
        const userId = localStorage.getItem("accountId");
        if (userId) {
          tabMode.value = "findIdResult";
          accountId.value = userId;
        }
      } else {
        const accessToken = localStorage.getItem("accessToken");
        if (accessToken) {
          tabMode.value = "findPwdResult";
          pwdUpdateToken.value = accessToken;
        }
      }
      localStorage.removeItem("accountId");
      localStorage.removeItem("accessToken");
    },
  });
};

// 이메일 인증 기반 아이디/비밀번호 찾기
const showEmailFindModal = ref(false);
const openEmailFind = () => {
  showEmailFindModal.value = true;
};
const onEmailFindVerified = async ({verificationContextId}) => {
  showEmailFindModal.value = false;
  try {
    if (tabMode.value === 'id') {
      const res = await apiClient.post('/v1/auth/email/find-id', {verificationContextId});
      accountId.value = res.data?.accountId;
      tabMode.value = 'findIdResult';
    } else {
      const res = await apiClient.post('/v1/auth/email/find-pwd', {verificationContextId});
      pwdUpdateToken.value = res.data?.accessToken;
      tabMode.value = 'findPwdResult';
    }
  } catch (e) {
    alert(e?.response?.data?.message || '처리 중 오류가 발생했습니다.');
  }
};

const accountPwd1FieldType = ref('password');
const accountPwd2FieldType = ref('password');
const toggleAccountPwd1Visibility = () => {
  accountPwd1FieldType.value = accountPwd1FieldType.value === 'password' ? 'text' : 'password';
};
const toggleAccountPwd2Visibility = () => {
  accountPwd2FieldType.value = accountPwd2FieldType.value === 'password' ? 'text' : 'password';
};

const accountPwd1Ref = ref(null);
const accountPwd2Ref = ref(null);
const accountPwdError1 = ref('');
const accountPwdError2 = ref('');
const validateAccountPwdForm = async () => {
  // Password validation
  const accountPwdRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?`~]).{8,16}$/;
  if (!accountPwdRegex.test(accountPwd1.value)) {
    accountPwdError1.value = '8~16자의 영문 대/소문자+숫자+특수문자를 사용해 주세요.';
    return false;
  } else {
    accountPwdError1.value = '';
  }

  if (accountPwd1.value !== accountPwd2.value) {
    accountPwdError2.value = '비밀번호가 일치하지 않습니다.';
    return false;
  } else {
    accountPwdError2.value = '';
  }
  return true;
}

const changeAccountPwd = async () => {
  const isValid = await validateAccountPwdForm();
  if (!isValid) {
    return;
  }
  try {
    await apiClient.put('/v1/auth/identity/password', {
      accountPwd: accountPwd1.value
    }, {
      headers: {
        Authorization: `Bearer ${pwdUpdateToken.value}` // Authorization 헤더에 JWT 토큰을 추가
      }
    });
    alert("비밀번호가 변경되었습니다.");
    pwdUpdateToken.value = '';
    uiStore.setLoginMode('none');
    //location.reload();
    //window.history.back();
    // window.location.replace('/');
    window.history.back();
    await router.push({name: route.name});
  } catch (error) {
    console.error(error);
  }
}

const onLoginPopState = (event) => {
  closeModal(event, true);
}

onMounted(async () => {
  uiStore.showOverlay();
  window.history.pushState({loginOpen: true}, "");
  window.addEventListener("popstate", onLoginPopState);
  await loadIdentityMode();
});

onUnmounted(() => {
  uiStore.setLoginMode('none');
  uiStore.hideOverlay();
  window.removeEventListener("popstate", onLoginPopState);
});

watch(() => mode.value, (newVal) => {
      if (newVal?.tap === 'findPassword') {
        changeTabMode("pwd");
        accountId.value = newVal.id;
      } else if (newVal?.tap === 'findId') {
        changeTabMode("id");
      }
    },
    {immediate: true}
);


</script>

<style scoped>
/* 해외 거주자(이메일) 인증 버튼: 가입 화면과 통일 — 흰 배경 + 검정 테두리.
   글로벌 .modal-find .find-cont .tab-cont button(노란 배경)보다 우선하도록 구체적 선택자 사용 */
.find-cont .tab-cont button.btn-email-find {
  margin-top: 12px;
  background: #fff;
  color: #151419;
  border: 1px solid #151419;
}

.email-find-note {
  margin-top: 10px;
  font-size: 13px;
  color: #999;
}
</style>